<template>
  <div class="mt-2">
    <table class="w-100" style="position:relative;">
      <thead>
        <tr>
          <td class="day-headline">{{ $t('common.days.MON_SHORT') }}</td>
          <td class="day-headline">{{ $t('common.days.TUE_SHORT') }}</td>
          <td class="day-headline">{{ $t('common.days.WED_SHORT') }}</td>
          <td class="day-headline">{{ $t('common.days.THU_SHORT') }}</td>
          <td class="day-headline">{{ $t('common.days.FRI_SHORT') }}</td>
          <td class="day-headline">{{ $t('common.days.SAT_SHORT') }}</td>
          <td class="day-headline">{{ $t('common.days.SUN_SHORT') }}</td>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(week, indexWeek) in asWeeks" :key="indexWeek">
          <td v-for="(day, indexDay) in week" :key="indexDay" class="day" :class="[dayCapacityClass(day), dayShowAsEmpty(day) ? 'day-capacity-empty' : '']">
            <div class="day-content">
              {{day.dayOfMonth}}
              <div :class=" (adminDashboard && overbooked(day)) ? 'd-block' : 'd-none' " class="overbooked">!</div>

              <div class="d-flex" v-if="isVisible(day) && (adminDashboard || dayCapacityClass(day) !== 'day-capacity-full')" @keyup.esc="closeShow(day.dayOfMonth)" style="height:100%;">
                <button @click="toggleShow(day.dayOfMonth)"  class="btn w-100 mx-auto pickTermin">
                  <span class="icon icon-kalender" aria-hidden="true"></span>
                  <span class="sr-only"> {{formatDay(day.timeSlots[0].date)}} {{ $t('common.timeSlot.srCalendarOpenButton') }}</span>
                </button>

                <div v-if="activeItem == day.dayOfMonth && showTimeSlot" role="dialog" aria-modal="true" class="timeslot-dialog" tabindex="0" >
                  <div class="d-block d-md-flex align-items-center mb-4">
                    <h2 class="dialog_label">
                      {{ $t('common.timeSlot.availableTime') }}
                    </h2>
                    <span class="ml-auto dialog_label">{{formatDay(day.timeSlots[0].date)}}</span>
                  </div>
                  <div class="timeslot-dialog-content mb-4 mt-3" v-for="(timeSlot, timeSlotIndex) in day.timeSlots" :key="indexDay + '-' + timeSlotIndex">
                    <div v-if="adminDashboard || (timeSlot.capacity > 0 )" class="row d-flex align-items-center">
                      <div class="col-6 col-sm-4 col-md-4 mb-2">
                        <span class="timeslot-dialog-name">{{ formatTime(timeSlot) }}</span><br>
                        {{ timeSlot.ticketCount }} {{ $t('common.from') }} {{ timeSlot.capacity}} {{ $t('common.occupied') }}.
                      </div>
                      <div class="col-6 col-sm-3 col-md-4 mb-2">
                        <div class="bg-lightblue w-100 h-20">
                          <div class="bg-darker h-20" :style="{ width: ticketPercent(timeSlot.ticketCount, timeSlot.capacity) +'%' }"></div>
                        </div>
                      </div>
                      <div class="col-12 col-sm-4 col-md-4 text-right text-xs-center mt-2 mt-sm-0 mb-2">
                        <button-time-slot v-if="adminDashboard" :message="$t('common.timeSlot.edit')" v-on:clicked="$emit('clicked', [room.id, timeSlot.id])" :class=" (timeSlot.capacity < timeSlot.ticketCount) ? 'btn-show-danger' : '' " />
                        <button-time-slot v-else-if="ticketPercent(timeSlot.ticketCount, timeSlot.capacity) < 100" :message="$t('common.timeSlot.bookTimeslot')" v-on:clicked="$emit('clicked', [room.id, timeSlot.id])" />
                        <button-time-slot v-else-if="timeSlot.failedRules.length > 0 && !showAusgebucht(day) " :message="$t('common.timeSlot.bookTimeslotTempFull')" :isDisabled="true" />
                        <button-time-slot v-else :message="$t('common.timeSlot.bookTimeslotFull')" :isDisabled="true" />
                      </div>
                    </div>
                  </div>
                  <div class="col-12 text-center mt-5 px-0">
                  <button class="btn btn-outline-brand1 btn-xs-w-100 px-5" @click="toggleShow(day.dayOfMonth)">
                    {{ $t('common.cancel') }}
                  </button>
                  </div>
                </div>
              </div>
              <div v-else-if="dayCapacityClass(day) === 'day-capacity-full'" class="d-flex" style="height:100%">
                <button disabled class="btn w-100 mx-auto pickTerminFull">
                  <span class="icon icon-schliesszeiten" aria-hidden="true"></span>
                  <span class="sr-only"> {{ $t('common.timeSlot.isFull') }}</span>
                </button>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'
import ButtonTimeSlot from '@/components/interaction/ButtonTimeSlot.vue'
import { CalendarDay } from '@/models/Calendar'
import { Room, TimeSlot } from '@/generated/openapi';
import _chunk from 'lodash.chunk';
import { formatDateString } from '@/utils/formatUtils'
import { GuiOptions } from '@/models/GuiOptions';
import config from '@/config/config';


export default defineComponent({
  name: 'CalendarMonthly',
  data() {
    return{
      showTimeSlot: false,
      activeItem: 0,
    }
  },
  components: {
    ButtonTimeSlot,
  },
  props: {
    room: Object as PropType<Room>,
    days: {
      type: Array as PropType<CalendarDay[]>,
      required: true
    },
    adminDashboard: { type: Boolean, default: false }
  },
  methods: {
    formatTime(timeSlot: TimeSlot) {
      return timeSlot.startTime.substr(0, 5) + '-' + timeSlot.endTime.substr(0, 5)
    },
    formatDay(day: string){
      return formatDateString(day)
    },
    dayCapacityClass(day: CalendarDay){
      if (day.timeSlots.length < 1) {
        return 'day-capacity-empty'
      }
      return day.timeSlots.find(timeslot => {
        return timeslot.capacity && typeof timeslot.ticketCount === 'number' && timeslot.capacity > timeslot.ticketCount
      }) !== undefined ? 'day-capacity-free' : 'day-capacity-full'
    },
    dayShowAsEmpty(day: CalendarDay){
      return day.timeSlots.some( timeslot => {
        return (!!timeslot.capacity && Array.isArray(timeslot.failedRules) && timeslot.failedRules.includes('timeslot_not_open'))
      })
    },
    toggleShow(itemId: number){
      this.showTimeSlot = !this.showTimeSlot;
      this.activeItem = itemId;
    },
    closeShow(itemId: number){
      this.showTimeSlot = false;
      this.activeItem = itemId;
    },
    ticketPercent(ts: number, cap: number){
      if( ((ts*100)/cap) > 100){
        return 100;
      }else{
        return (ts*100)/cap;
      }
    },
    isVisible(day: CalendarDay){
      return day.timeSlots.some( timeslot => {
        if( config.interface === GuiOptions.admin ){
          return true;
         }else{
           return (!!timeslot.capacity && Array.isArray(timeslot.failedRules) && !timeslot.failedRules.includes('timeslot_not_open'))
         }
      })
    },
    dayHasFailRule(day: CalendarDay){
      return day.timeSlots.some( timeslot => {
        if( config.interface === GuiOptions.admin ){
          return true;
         }else{
           return (!!timeslot.capacity && Array.isArray(timeslot.failedRules) && timeslot.failedRules.length > 0)
         }
      })
    },
    showAusgebucht(day: CalendarDay){
      return day.timeSlots.some( timeslot => {
          return ( Array.isArray(timeslot.failedRules) && (timeslot.failedRules.includes('timeslot_no_tickets_left')))
      })
    },
    overbooked(day: CalendarDay): boolean {
        return day.timeSlots.some( timeslot => (timeslot.ticketCount || 0) > (timeslot.capacity || 0))
    }
  },
  computed: {
    asWeeks(): CalendarDay[][] {
      return _chunk(this.days, 7)
    }
  }
});
</script>
